import { get, post, put, del } from "aws-amplify/api";

const NetworkGet = async ({ networkId }) => {
  try {
    //Adding nostall prop to stop browser from queuing/stalling dup calls
    const { body } = await get({
      apiName: "boreas",
      path: "network",
      options: {
        queryParams: { networkId, nostall: new Date().getTime() },
      },
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const NetworkGetAll = async () => {
  try {
    const { body } = await get({
      apiName: "boreas",
      path: "networks",
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const NetworkGetUserNetworks = async () => {
  try {
    const { body } = await get({
      apiName: "boreas",
      path: "user-networks",
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const NetworkCreate = async ({ createNetworkBodyData }) => {
  try {
    const { body } = await post({
      apiName: "boreas",
      path: "network",
      options: {
        body: createNetworkBodyData,
      },
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const NetworkUpdate = async ({ updateNetworkBodyData }) => {
  try {
    const { body } = await put({
      apiName: "boreas",
      path: "network",
      options: {
        body: updateNetworkBodyData,
      },
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const NetworkDelete = async ({
  deleteNetworkId,
  reactivate = "false",
}) => {
  try {
    const { body } = await del({
      apiName: "boreas",
      path: "network",
      options: {
        queryParams: { deleteNetworkId, reactivate },
      },
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const Methods = {
  NetworkGet,
  NetworkGetAll,
  NetworkCreate,
  NetworkUpdate,
  NetworkDelete,
  NetworkGetUserNetworks
};

export default Methods;
